import { type MaskAdapter } from '.';

// cpf example: 000.000.000-00
// cnpj example: 00.000.000/0000-00
// combined mask: 000.000.000-00 or 00.000.000/0000-00
// use input length to determine which mask to apply

const cpfOrCnpjMask: MaskAdapter = {
  apply: value => {
    if (!value) {
      return '';
    }

    const cleaned = value.toString().replace(/[^\d]/gi, '');

    if (cleaned.length <= 11) {
      // apply cpf mask
      const part1 = cleaned.substring(0, 3);
      const part2 = cleaned.length > 3 ? cleaned.substring(3, 6) : '';
      const part3 = cleaned.length > 6 ? cleaned.substring(6, 9) : '';
      const part4 = cleaned.length > 9 ? cleaned.substring(9, 11) : '';
      let masked = part1;
      if (part2) masked += '.' + part2;
      if (part3) masked += '.' + part3;
      if (part4) masked += '-' + part4;
      return masked;
    } else {
      // apply cnpj mask
      const part1 = cleaned.substring(0, 2);
      const part2 = cleaned.length > 2 ? cleaned.substring(2, 5) : '';
      const part3 = cleaned.length > 5 ? cleaned.substring(5, 8) : '';
      const part4 = cleaned.length > 8 ? cleaned.substring(8, 12) : '';
      const part5 = cleaned.length > 12 ? cleaned.substring(12, 14) : '';
      let masked = part1;
      if (part2) masked += '.' + part2;
      if (part3) masked += '.' + part3;
      if (part4) masked += '/' + part4;
      if (part5) masked += '-' + part5;
      return masked;
    }
  },
  clean: value => {
    if (!value) {
      return '';
    }

    return value.toString().replace(/[^\d]/gi, '');
  }
};

export default cpfOrCnpjMask;
